// import BrandLogo from "/static/images/tenants/lego/Lego F1 Logo.png";
import { legoContent } from "../brandContent/legoBrandContent";
import { legoMeta } from "../brandMetaData/legoMetaData";
import { legoPrize } from "../brandPrize/legoPrize";
import { lego } from "../brandThemes/lego";

export const LEGO_brandVariables = {
  tenantId: "LEGO-gdjkr", // For picking wich leaderboard to show
  themeId: "lego",
  gameStyle: "racing", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "f12025", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: null,
  brandLogoSize: 200,
  leaderboardLength: 3,
  leaderboardEntrys: null,
  theme: lego,
  prize: legoPrize,
  content: legoContent,

  metaInfo: legoMeta,

  disclaimer:
    "LEGO® and the LEGO logo are trademarks of the LEGO Group. ©2024 The LEGO Group. The F1 logo, FORMULA 1, F1, GRAND PRIX and related marks are trademarks of Formula One Licensing BV, a Formula 1 company. All other trademarks, logos and copyrights, including those of the teams featured, are the property of their respective owners. All rights reserved. OFFICIAL LICENSEE OF FORMULA 1®",
};
